import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useAppSelector } from 'shared/lib';

import { formBlockFFSelector, useDictionaries } from 'entities/creditForm';
import { wlBlockFFSelector } from 'entities/whiteLabels';

export const Purpose: FC<IFieldFactoryProps> = (props) => {
  const { type, ...other } = props;
  const { purposes } = useDictionaries(['purposes']);
  const blockWllFF = useAppSelector(wlBlockFFSelector);
  const formBlockFF = useAppSelector(formBlockFFSelector);
  const preSelectedPurpose = blockWllFF?.preSelectedPurpose || formBlockFF?.preSelectedPurpose;

  const validPurposes = preSelectedPurpose
    ? purposes.filter((purpose) => purpose.value === preSelectedPurpose)
    : purposes;

  return (
    <ControlledCustomSelect
      {...other}
      name={type}
      options={validPurposes}
      // Заглушка чтобы не отрисовывать иконку дропдауна
      icon={preSelectedPurpose && ' '}
      readOnly={Boolean(preSelectedPurpose)}
      withCrossIcon={false}
    />
  );
};
